import React, { useEffect, useState } from 'react'
import CoursesList from './CoursesList'
import SetPage from '../../data/SetPage'
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import ModalStyle from '../../data/ModalStyle'
import Close from '@mui/icons-material/Close'
import { PlayCircle } from '@mui/icons-material'
import Box from '@mui/material/Box';
import { Helmet } from 'react-helmet';
import img from "../../assets/images/connection/avatar10.jpg"
import img2 from "../../assets/images/course/SpecializationCourse.png"

const SpecializationCourses = () => {

  useEffect(() => {
    SetPage("Specialization Courses")
    window.scrollTo(0, 0)
  }, [])


  const [demo, setdemo] = useState(false)
  return (

    <>

      <Helmet>‍
        <title>Job Guaranteed Courses & Training Programs, Specialization Courses - SiliconMinds </title>‍
        <meta name="description" content="Unlock Your Career Potential with Our 3-4 Month Courses: Guaranteed Internships and Placement Opportunities Included. Elevate Your SiliconMinds and Land your dream job today." />
        <meta name="twitter:card" content="" />
        <meta name="twitter:site" content="@skillsuprise" />
        <meta name="twitter:creator" content="@skillsuprise" />
        <meta name="twitter:title" content="" />
        <meta name="twitter:description" content="" />
        <meta name="twitter:image" content="" />
        <meta property="og:title" content="" />
        <meta property="og:description" content="" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:site_name" content="Skills Uprise" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="fb:app_id" content="ID_APP_FACEBOOK" />
      </Helmet>
      <Modal
        open={demo}
        onClose={() => setdemo(false)}

      >
        <Box sx={ModalStyle} className="col-lg-4 col-md-5 br-5 col-sm-6 col-11 p-2">
          <div className="d-flex justify-content-between">
            <h4>Introduction</h4>
            <Close className="text-danger" type="button" onClick={() => setdemo(false)} />
          </div>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <video poster="https://skillsuprise.com/data/images/specialization-trainings-poster.png" className="w-100" autoPlay src="https://skillsuprise.com/data/videos/specialization-demo.mp4"></video>
          </Typography>
        </Box>
      </Modal>
      <section className="banner-section offline-crumb">

        {/* Background Shapes */}
        <img className="img-fluid d-none d-lg-flex banner-bg1" src="/assets/img/bg/bg-15.png" alt="" />
        <img className="img-fluid d-none d-lg-flex banner-bg2" src="/assets/img/bg/bg-16.png" alt="" />
        <img className="img-fluid d-none d-lg-flex banner-bg3" src="/assets/img/bg/bg-17.png" alt="" />
        <img className="img-fluid d-none d-lg-flex banner-bg4" src="/assets/img/bg/bg-18.png" alt="" />

        <div className="container">
          <div className="row align-items-center justify-content-between">

            {/* LEFT CONTENT */}
            <div className="col-xl-7 col-lg-7 text-white">
              <div className="banner-content pe-lg-5">

                <span className="hero-title">
                  Specialization Courses
                </span>

                <h1 className="mb-4">
                  Industry-Ready <span>Programs</span> for Career Growth{" "}
                  <span>Anywhere</span>
                </h1>

                <p className="fs-lg mb-4 text-light">
                  Gain real-world skills with expertly designed specialization
                  programs. Flexible, online, and crafted to make you job-ready
                  with guaranteed internship and placement support.
                </p>

                <button
                  onClick={() => setdemo(true)}
                  className="btn btn-orng rounded-pill px-4 py-2"
                >
                  <PlayCircle className="me-2" />
                  Watch Demo
                </button>

                {/* COUNTERS */}
                <div className="d-flex gap-4 flex-wrap mt-4 mb-2">
                  <div className="counter-item">
                    <div className="count-content">
                      <h5 className="text-warning mb-0">10K+</h5>
                      <p className="mb-0 text-light">Enrolled Students</p>
                    </div>
                  </div>

                  <div className="counter-item">
                    <div className="count-content">
                      <h5 className="text-info mb-0">50+</h5>
                      <p className="mb-0 text-light">Specializations</p>
                    </div>
                  </div>

                  <div className="counter-item">
                    <div className="count-content">
                      <h5 className="text-white fw-semibold mb-0">Guaranteed</h5>
                      <p className="mb-0 text-light">Internship & Placement</p>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            {/* RIGHT CARD (TEXT ONLY CHANGES) */}
            <div className="col-xl-4 col-lg-5 d-none d-lg-block">
              <div className="banner-course-card">
                <div className="hero-course-card mb-5">

                  <div className="hero-course-image">
                    <img src={img2} alt="Course" />
                    <div className="hero-brand">N</div>
                  </div>

                  <div className="hero-course-body">
                    <div className="hero-author">
                      <img src={img} alt="Instructor" />
                      <span className="text-dark">David Benitz</span>
                      <span className="hero-category">Specialization</span>
                    </div>

                    <h5 className="text-dark">
                      Advanced Business & Management Specialization
                    </h5>

                    <div className="hero-rating d-flex">
                      <div>⭐ 5.0 <span>(2,100 Reviews)</span></div>
                      {/* <button
                        onClick={() => setdemo(true)}
                        className="btn btn-orng rounded-pill px-2 py-1 ms-auto"
                      >
                        <PlayCircle className="me-2" />
                        Watch Demo
                      </button> */}
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <div className="container sm-p-0 pb-5 mb-5">
        <CoursesList mode={"specialization"} />
      </div>


    </>

  )
}

export default SpecializationCourses